import React from 'react';

import Header from 'react-scale/components/elements/header';
import Hero from 'react-scale/components/pages/open-datasets/Hero';
import HighlightDatasets from 'react-scale/components/tailwind/highlight-datasets';
import OpenDatasetsList from 'react-scale/components/pages/open-datasets/OpenDatasetsList';
import TryBanner from 'react-scale/components/sections/cta/simple-centered';
import Footer from 'react-scale/components/elements/footer';

const OpenDatasets = () => (
  <div className="bg-black">
    <div className="bg-black">
      <Header
        title="Open AV & NLP Datasets | Scale AI"
        canonical="https://scale.com/open-av-datasets"
        ogImg="/static/images/pages/open-datasets/og.png"
        theme={undefined}
        background={undefined}
        border={undefined}
        borderColor={undefined}
        announcement={undefined}
        videoOverlay={false}
        demoMode={undefined}
        signupURL={undefined}
        noIndex={undefined}
      />
      <Hero />
    </div>
    <HighlightDatasets />
    <OpenDatasetsList />
    <TryBanner border title="Get started for free today!" />
    <Footer border />
  </div>
);

export default OpenDatasets;
